import { Routes } from '@angular/router';
import { APP_ROUTES } from '../shared/constants';

export const pageRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      {
        path: APP_ROUTES.home,
        title: APP_ROUTES.home,
        pathMatch: 'full',
        loadComponent: () =>
          import('./home/home.component').then((m) => m.HomeComponent),
      },

      //#region TEST
      // {
      //   path: APP_ROUTES.selectFlight,
      //   title: APP_ROUTES.selectFlight,
      //   loadComponent: () =>
      //     import('./booking/select-flight/select-flight.component').then(
      //       (m) => m.SelectFlightComponent,
      //     ),
      // },
      //#endregion TEST

      {
        path: `${APP_ROUTES.selectFlight}/:from/:to/:date`,
        title: APP_ROUTES.selectFlight,
        loadComponent: () =>
          import('./booking/select-flight/select-flight.component').then(
            (m) => m.SelectFlightComponent,
          ),
      },
      {
        path: `${APP_ROUTES.go}/:from/:to/:date`,
        title: APP_ROUTES.go,
        loadComponent: () =>
          import('./booking/select-flight/select-flight.component').then(
            (m) => m.SelectFlightComponent,
          ),
      },
      {
        path: APP_ROUTES.passengerInformation,
        title: APP_ROUTES.passengerInformation,
        loadComponent: () =>
          import('./booking/passenger-info/passenger-info.component').then(
            (m) => m.PassengerInfoComponent,
          ),
      },
      // {
      //   path: APP_ROUTES.selectService,
      //   title: APP_ROUTES.selectService,
      //   loadComponent: () =>
      //     import('./booking/select-service/select-service.component').then(
      //       (m) => m.SelectServiceComponent,
      //     ),
      // },
      {
        path: APP_ROUTES.payment,
        title: APP_ROUTES.payment,
        loadComponent: () =>
          import('./booking/payment/payment.component').then(
            (m) => m.PaymentComponent,
          ),
      },
      {
        // For Booking
        path: `${APP_ROUTES.paymentSuccess}`,
        title: APP_ROUTES.paymentSuccess,
        loadComponent: () =>
          import('./booking/payment-success/payment-success.component').then(
            (m) => m.PaymentSuccessComponent,
          ),
      },
      {
        // For Review Booking
        path: `${APP_ROUTES.paymentSuccess}/:bookingId`,
        title: APP_ROUTES.paymentSuccess,
        loadComponent: () =>
          import('./booking/payment-success/payment-success.component').then(
            (m) => m.PaymentSuccessComponent,
          ),
      },
      {
        // For Review Booking — cùng màn với route trên, chỉ khác tên. Giữ cả
        // hai: route cũ để không vỡ link đã gửi cho khách, route này để luồng
        // kết quả OnePay (kể cả failed/pending) không đáp xuống một URL nói
        // "thanh toán thành công".
        path: `${APP_ROUTES.bookingDetail}/:bookingId`,
        title: APP_ROUTES.bookingDetail,
        loadComponent: () =>
          import('./booking/payment-success/payment-success.component').then(
            (m) => m.PaymentSuccessComponent,
          ),
      },
      {
        path: APP_ROUTES.cheapTicket,
        title: APP_ROUTES.cheapTicket,
        loadComponent: () =>
          import('./cheap-ticket/cheap-ticket.component').then(
            (m) => m.CheapTicketComponent,
          ),
      },
      {
        path: APP_ROUTES.promotion,
        title: APP_ROUTES.promotion,
        loadComponent: () =>
          import('./promotion/promotion.component').then(
            (m) => m.PromotionComponent,
          ),
      },
      {
        path: APP_ROUTES.contact,
        title: APP_ROUTES.contact,
        loadComponent: () =>
          import('./contact/contact.component').then((m) => m.ContactComponent),
      },
      { path: '**', redirectTo: APP_ROUTES.home },
    ],
  },
];
